import moment from 'moment';
import type { ExpiryTimeGranularity } from '@x-guard/xgac-types/xgac';
import { calculateDateAfterTimeGranularity } from './timeGranularityUtils';

export const isFirstIssuedWithinValidityPeriod = (
  firstIssuedOn: string | undefined,
  validityPeriod: ExpiryTimeGranularity | undefined,
): boolean => {

  if (!firstIssuedOn || !validityPeriod) return false;

  const expiryFromFirstIssued = calculateDateAfterTimeGranularity(
    firstIssuedOn,
    validityPeriod,
  );
  if (!expiryFromFirstIssued) return false;

  return moment(expiryFromFirstIssued)
    .startOf('day')
    .isAfter(moment().startOf('day'));

};

export const getAutofillDatesFromFirstIssued = (
  firstIssuedOn: string,
  validityPeriod: ExpiryTimeGranularity | undefined,
): { lastReceivedOn: string; expiryDate: string } | undefined => {

  if (!isFirstIssuedWithinValidityPeriod(firstIssuedOn, validityPeriod)) {

    return undefined;

  }

  const expiryDate = calculateDateAfterTimeGranularity(firstIssuedOn, validityPeriod);
  if (!expiryDate) return undefined;

  return {
    lastReceivedOn: firstIssuedOn,
    expiryDate,
  };

};
